export const FILTERS = {
  YEAR: 'year',
  COUNTRY: 'country',
};
